import { IconButton, Tooltip } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown, faReceipt } from "@fortawesome/pro-regular-svg-icons"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    actionButton: {
        width: "2.5rem",
        height: "2.5rem",
        marginRight: "1.5rem",
    },
    actionIcon: {
        color: theme.palette.tailwind.slate[800],
        fontSize: "1.25rem",
    },
    chevronIcon: {
        color: theme.palette.tailwind.slate[400],
        fontSize: "1rem",
        transition: "transform .2s",
    },
    chevronOpen: {
        transform: "rotate(180deg)",
    },
}))

type PanelHeaderActionsProps = Readonly<{
    onShowAll: () => void
    isOpen: boolean
    onToggle: () => void
    collapseAriaLabel: string
    expandAriaLabel: string
}>

export function PanelHeaderActions({
    onShowAll,
    isOpen,
    onToggle,
    collapseAriaLabel,
    expandAriaLabel,
}: PanelHeaderActionsProps) {
    const { classes, cx } = useStyles()

    return (
        <>
            <LocalizedStrict id="user-home-panel-action-show-all" attrs={{ title: true }}>
                <Tooltip title="Show all">
                    <IconButton size="small" onClick={onShowAll} className={classes.actionButton}>
                        <FontAwesomeIcon icon={faReceipt} className={classes.actionIcon} />
                    </IconButton>
                </Tooltip>
            </LocalizedStrict>
            <IconButton size="small" onClick={onToggle} aria-label={isOpen ? collapseAriaLabel : expandAriaLabel}>
                <FontAwesomeIcon
                    icon={faChevronDown}
                    className={cx(classes.chevronIcon, isOpen && classes.chevronOpen)}
                />
            </IconButton>
        </>
    )
}
